import { render, staticRenderFns } from "./LoginIllu.vue?vue&type=template&id=063e66a2&scoped=true&"
import script from "./LoginIllu.vue?vue&type=script&lang=js&"
export * from "./LoginIllu.vue?vue&type=script&lang=js&"
import style0 from "./LoginIllu.vue?vue&type=style&index=0&id=063e66a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063e66a2",
  null
  
)

export default component.exports